var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 54,
    height: 54,
    rx: 27,
    stroke: "#FB7C2F",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_516_103",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_516_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 26.6668C20.7111 26.6668 19.6111 26.2113 18.7 25.3002C17.7889 24.3891 17.3333 23.2891 17.3333 22.0002C17.3333 20.7113 17.7889 19.6113 18.7 18.7002C19.6111 17.7891 20.7111 17.3335 22 17.3335C23.2889 17.3335 24.3889 17.7891 25.3 18.7002C26.2111 19.6113 26.6666 20.7113 26.6666 22.0002C26.6666 23.2891 26.2111 24.3891 25.3 25.3002C24.3889 26.2113 23.2889 26.6668 22 26.6668ZM22 24.0002C22.5555 24.0002 23.0278 23.8057 23.4166 23.4168C23.8055 23.0279 24 22.5557 24 22.0002C24 21.4446 23.8055 20.9724 23.4166 20.5835C23.0278 20.1946 22.5555 20.0002 22 20.0002C21.4444 20.0002 20.9722 20.1946 20.5833 20.5835C20.1944 20.9724 20 21.4446 20 22.0002C20 22.5557 20.1944 23.0279 20.5833 23.4168C20.9722 23.8057 21.4444 24.0002 22 24.0002ZM34 38.6668C32.7111 38.6668 31.6111 38.2113 30.7 37.3002C29.7889 36.3891 29.3333 35.2891 29.3333 34.0002C29.3333 32.7113 29.7889 31.6113 30.7 30.7002C31.6111 29.7891 32.7111 29.3335 34 29.3335C35.2889 29.3335 36.3889 29.7891 37.3 30.7002C38.2111 31.6113 38.6666 32.7113 38.6666 34.0002C38.6666 35.2891 38.2111 36.3891 37.3 37.3002C36.3889 38.2113 35.2889 38.6668 34 38.6668ZM34 36.0002C34.5555 36.0002 35.0278 35.8057 35.4166 35.4168C35.8055 35.0279 36 34.5557 36 34.0002C36 33.4446 35.8055 32.9724 35.4166 32.5835C35.0278 32.1946 34.5555 32.0002 34 32.0002C33.4444 32.0002 32.9722 32.1946 32.5833 32.5835C32.1944 32.9724 32 33.4446 32 34.0002C32 34.5557 32.1944 35.0279 32.5833 35.4168C32.9722 35.8057 33.4444 36.0002 34 36.0002ZM19.2 38.6668L17.3333 36.8002L36.8 17.3335L38.6666 19.2002L19.2 38.6668Z",
    fill: "#FB7C2F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.174c869c5a263c9377f32867b71fec15.svg";
export { ForwardRef as ReactComponent };